import { convertPaymentStatus, PaymentStatus } from '@/api/enumerations';
import { Box } from '@mui/material';
import { memo } from 'react';

type StatusStyle = {
  bg: string;
  color: string;
};

const getStatusStyles = (status: PaymentStatus): StatusStyle => {
  switch (status) {
    case PaymentStatus.PENDING:
      return { bg: '#FEF3C7', color: '#FB923C' };
    case PaymentStatus.APPROVED:
      return { bg: '#CAE6FF', color: '#6366F1' };
    case PaymentStatus.INVOICED:
      return { bg: '#00B39B1A', color: '#1D9E75' };
    case PaymentStatus.PAID:
      return { bg: '#B668FD', color: '#FFFFFF' };
    case PaymentStatus.CANCELLED:
      return { bg: '#FFEBEE', color: '#D32F2F' };
    case PaymentStatus.REFUNDED:
      return { bg: '#FB923C1F', color: '#E67715' };
    default:
      return { bg: '#F5F5F5', color: '#9E9E9E' };
  }
};

export const PaymentStatusBadge = memo(function PaymentStatusBadge({
  status,
}: {
  status: PaymentStatus;
}) {
  const styles = getStatusStyles(status);
  const label = convertPaymentStatus(status);

  return (
    <Box
      sx={{
        backgroundColor: styles.bg,
        color: styles.color,
        borderRadius: '16px',
        padding: '4px 12px',
        height: 'fit-content',
        minWidth: 84,
        textAlign: 'center',
        fontWeight: 600,
      }}
    >
      {label}
    </Box>
  );
});
